import React from "react"
import InstituteSearchContainer from "../../containers/InstituteSearchContainer"

const InstituteSearchPage = () => {
  return <InstituteSearchContainer />
}
export default InstituteSearchPage
